import React from 'react';
import { Avatar, AvatarGroup, Box, Tooltip } from '@mui/material';
import type { EasyEstimateKosztorysMember } from '../../services/realtimeService';
import { colorForUser } from '../board/useBoardPresence';

const initials = (name?: string) => {
  const src = (name || '').trim();
  if (!src) return '?';
  const parts = src.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return src.slice(0, 2).toUpperCase();
};

type Props = {
  members: EasyEstimateKosztorysMember[];
  /** Śledzenie kursora arkusza tego użytkownika (klik ponownie — wyłącza). */
  followedUserId?: string | null;
  onMemberClick?: (userId: string) => void;
};

/** Awatary obok filtra Szukaj — kto jeszcze ma otwarty kosztorys (zakładka Kosztorys). */
const EasyEstimateKosztorysPresenceAvatars: React.FC<Props> = ({
  members,
  followedUserId = null,
  onMemberClick,
}) => {
  if (members.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        minHeight: 32,
      }}
      aria-label="Inni użytkownicy przy tym kosztorysie"
    >
      <AvatarGroup
        max={6}
        sx={{
          '& .MuiAvatar-root': {
            width: 24,
            height: 24,
            fontSize: 10,
            fontWeight: 600,
            border: '2px solid #fff',
            boxShadow: '0 0 0 1px rgba(0,0,0,0.08)',
          },
        }}
      >
        {members.map((m) => (
          <Tooltip
            key={m.userId}
            title={(m.displayName || 'Użytkownik') + (onMemberClick ? ' — kliknij, aby śledzić komórkę w tabeli' : '')}
            arrow
          >
            <Avatar
              src={m.avatarUrl}
              onClick={
                onMemberClick
                  ? (e) => {
                      e.stopPropagation();
                      onMemberClick(m.userId);
                    }
                  : undefined
              }
              sx={{
                bgcolor: colorForUser(m.userId),
                outline: `1px solid ${colorForUser(m.userId)}`,
                outlineOffset: 0,
                ...(onMemberClick
                  ? {
                      cursor: 'pointer',
                      ...(followedUserId === m.userId
                        ? { boxShadow: `0 0 0 2px ${colorForUser(m.userId)}, 0 0 0 4px #fff` }
                        : {}),
                    }
                  : {}),
              }}
            >
              {initials(m.displayName)}
            </Avatar>
          </Tooltip>
        ))}
      </AvatarGroup>
    </Box>
  );
};

export default EasyEstimateKosztorysPresenceAvatars;
